import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="bg-ivory py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-184" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-185" data-mp="o3x58w0bc74w">
        <SectionHeading id="summary-title" tone="onLight" data-id="element-186" data-mp="j883cm0tme5f">Tutto ciò che è <span className="text-gold-dark" data-id="element-187" data-mp="1gup09q5n6pqn">incluso:</span></SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-2xl border border-gold/50 bg-white/70 shadow-lg shadow-navy/10 sm:grid-cols-2" data-id="element-188" data-mp="1gsuniz4iy3xn">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-ivory-dark p-4 sm:odd:border-r" data-id="element-189" data-mp="16vg7v1qfdj6e">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-190" data-mp="12ump0mruaukd">
                <CheckIcon className="h-3.5 w-3.5 text-navy" aria-hidden="true" data-id="element-191" data-mp="3rkvurlmiwnqr" />
              </span>
              <b className="text-sm text-navy" data-id="element-192" data-mp="3nnhr09hm3865">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}